module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/cover-pc-83e7faf3f143b4af1cc68335ce39a0a4.webp";